import { vservice } from '@niknevis/vue-modules'
import { PanelCampaignRoute } from '@/modules/base-campaign/routes/panel-campaign.route'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'

@vservice()
export class PanelCampaignService {
  constructor(
    private readonly campaignRoute: PanelCampaignRoute
  ) {
  }

  allCampaigns() {
    return HTTP.get(
      this.campaignRoute.allCampaigns()
    )
  }
}